import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "@cds/core/button/register.js";
import "@cds/core/icon/register.js";
import "@cds/core/dropdown/register.js";
import "@cds/core/divider/register.js";
import "@webcomponents/custom-elements/custom-elements.min.js";
import "@clr/icons/clr-icons.min.css";
import "@clr/icons/shapes/technology-shapes.js";
import "../App.css";
import "./Home.css";
import '../output.css';

function Home() {
  const [news, setNews] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL || ''}/api/news`
        );
        setNews(response.data);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchNews();
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % news.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + news.length) % news.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="App">
      <div id="outer-container">
        <main id="page-wrap">
          <main className="text">
            <section className="columns">
              <div className="column">
                <img
                  className="home_image1"
                  src="https://res.cloudinary.com/djunroohl/image/upload/c_crop,h_1701,w_600/v1720396474/greenfields_jcajzf.jpg"
                  alt="Green fields"
                />
              </div>
              <div className="column">
                <div>
                  <p className="home-text home-card">
                    The project Multidisciplinära Åtaganden för Sveriges gen-IV
                    Teknologi och Expertis (Multidisciplinary Commitments for
                    Sweden&#39;s Gene IV Technology and Expertise), MÅSTE, lays
                    the foundation for real understanding of the knowledge and
                    challenges for the implementation of a Gen IV electricity
                    production system. <br></br>
                    <br></br> It also works as a ground for increasing the base
                    line of younger scientist and professionals in the radiation
                    science sector bringing a huge benefit for Sweden. MÅSTE not
                    only brings the ability to continue the existing nuclear
                    fleet but it is also the corner stone for any new build
                    power system and replies to other needs such as radiological
                    awareness, protection and hospital capabilities.
                    <br></br>
                    <br></br> MÅSTE promotes the younger research leaders and,
                    in this way, contributes to sustainability of the high
                    academic level at the Swedish universities where many senior
                    researchers will retire in the next 1-2 decades.
                  </p>
                  <div className="home-card">
                  The MÅSTE project (P2023-01281) has been supported by the Swedish Energy Agency.
                  </div>
                </div>
                <section className="news-section">
                  <h2 className="news-headline">Latest News</h2>
                  {Array.isArray(news) && news.length > 0 ? (
                    <div className="news-carousel">
                      <div className="carousel-container">
                        <button 
                          className="carousel-nav prev" 
                          onClick={prevSlide}
                          disabled={news.length <= 1}
                        >
                          ❮
                        </button>
                        
                        <div className="news-item-home">
                          <h3 style={{ textAlign: 'left' }}>{news[currentSlide]?.title}</h3>
                          <div className="news-content-container">
                            {news[currentSlide]?.image_url && (
                              <img
                                src={news[currentSlide].image_url}
                                alt={news[currentSlide].title}
                                className="news-image-home"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "https://res.cloudinary.com/djunroohl/image/upload/v1739826909/fcpw9zqxs0wwxnmrp62n.svg";
                                }}
                              />
                            )}
                            <div className="news-text-content">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: news[currentSlide]?.content?.length > 150
                                    ? `${news[currentSlide].content.substring(0, 150)}...`
                                    : news[currentSlide]?.content || '',
                                }}
                              />
                              <div className="news-meta">
                                <p className="news-author">By {news[currentSlide]?.author}</p>
                                <p className="news-date">
                                  {new Date(news[currentSlide]?.created_at).toLocaleDateString()}
                                </p>
                              </div>
                              <Link to={`/news/${news[currentSlide]?.id}`} className="read-more-btn">
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                        
                        <button 
                          className="carousel-nav next" 
                          onClick={nextSlide}
                          disabled={news.length <= 1}
                        >
                          ❯
                        </button>
                      </div>
                      
                      {news.length > 1 && (
                        <div className="carousel-dots">
                          {news.map((_, index) => (
                            <button
                              key={index}
                              className={`dot ${index === currentSlide ? 'active' : ''}`}
                              onClick={() => goToSlide(index)}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="no-news">
                      <p>No news available</p>
                    </div>
                  )}
                </section>
              </div>
              <div className="column">
                <img
                  className="home_image2"
                  src="https://res.cloudinary.com/djunroohl/image/upload/c_crop,e_improve,g_auto,h_1707,w_600,x_0/v1720396474/greenfields_jcajzf.jpg"
                  alt="Green fields"
                />
              </div>
            </section>
          </main>
        </main>
      </div>
    </div>
  );
}

export default Home;